export const convertLineBreak = (sentence: string) =>
    sentence
        .split(/<br\s*\/?>|\n/gi)
        .reduce<React.ReactNode[]>((acc, item, index) => {
            if (index > 0) acc.push(<br key={`br-${index}`} />);
            acc.push(item);
            return acc;
        }, []);
